export default __webpack_public_path__ + "static/media/Royal Zingaran Sabre.25332c3b.jpg";